import * as React from "react";
import * as ReactRedux from "react-redux";

const rehypeReact = require("rehype-react");

import { HttpHeadersInMarkdown } from "./HttpHeaders";
import Example from "../components/Example/Example";
import { CopyToClipboard } from "react-copy-to-clipboard";
import * as Tooltip from "rc-tooltip";

import "rc-tooltip/assets/bootstrap.css";
import "../styles/doc-content.scss";
import HttpVerb from "./HttpVerb";
import Heading from "./Heading";

import { actions as docPageActions } from "../reducers/doc_page";

const renderAst = new rehypeReact({
	createElement: React.createElement,
	components: {
		"http-headers": HttpHeadersInMarkdown,
		example: Example,
	},
}).Compiler;

interface DocContentProps {
	isLoggedIn: boolean;
	isLabOpen: boolean;
	isDrawerOpen?: boolean;
	hasDrawer?: boolean;
	title: string;
	group: {
		id: string;
		title: string;
	};
	htmlAst: any;

	apiverb: string;
	apiurl: string;

	style?: any;

	openDrawer(): any;
}

class DocContent extends React.Component<DocContentProps> {
	state = {
		copiedToClipboard: false,
	};

	timeout = null;

	copyText() {
		clearTimeout(this.timeout);
		this.setState({ copiedToClipboard: true });
		this.timeout = setTimeout(() => this.setState({ copiedToClipboard: false }), 3000);
	}

	render() {
		const props = this.props;

		return (
			<div
				className="docSearch-content doc-content"
				style={{
					paddingTop: "calc(60px + 1.61em)",
					...(props.style || {}),
				}}
			>
				<Heading
					hasDrawer={props.hasDrawer}
					openDrawer={props.openDrawer}
					isLabOpen={props.isLabOpen}
				>
					{props.title}
				</Heading>

				<div
					style={{
						marginLeft: "1.61em",
						marginBottom: "1em",
					}}
				>
					{props.apiurl === undefined ||
					props.apiurl === null ||
					props.apiverb === undefined ||
					props.apiverb === null ? null : (
						<>
							<HttpVerb verb={props.apiverb} />

							<Tooltip
								placement="top"
								overlay={<span>{this.state.copiedToClipboard ? "Copied" : "Copy"}</span>}
							>
								<CopyToClipboard text={props.apiurl} onCopy={this.copyText.bind(this)}>
									<span
										style={{
											cursor: "pointer",
											marginLeft: "1em",
											fontFamily: "Fira Mono",
										}}
									>
										{props.apiurl}
									</span>
								</CopyToClipboard>
							</Tooltip>
						</>
					)}
				</div>

				{renderAst(props.htmlAst)}
			</div>
		);
	}
}

const mapDispatchToProps = {
	openDrawer: docPageActions.openDrawer,
};

export default ReactRedux.connect(
	null,
	mapDispatchToProps
)(DocContent);



// WEBPACK FOOTER //
// ./src/components/DocContent.tsx